import useErrorHandler from "../../../hook/useErrorHandler"
import useSingleProjectCore from "./useSingleProjectCore"


export const useSingleProject = (projectId?: string | null) => {
    const {handleNetworkError} = useErrorHandler()
    return useSingleProjectCore(projectId, handleNetworkError, null)
}